import {PaymentMethodTerms} from "../../resources/billpayTerms"

export interface PaymentMethodValidationItem {
	label: string
	terms: PaymentMethodTerms
}

/**
 * Validates that payment method fees are provided when payment methods are allowed.
 * @param methods Array of payment methods to validate
 * @param addToast Function to display error toast messages
 * @returns true if all validations pass, false otherwise
 */
export function validatePaymentMethodFees(
	methods: Array<PaymentMethodValidationItem>,
	addToast: (message: string, options: {appearance: "error"}) => void
): boolean {
	for (const {label, terms} of methods) {
		if (terms.allowed && (!terms.fee || terms.fee.tiers.length === 0)) {
			addToast(`${label} fee is required when ${label} is allowed`, {appearance: "error"})
			return false
		}
	}
	return true
}
